/*
*@/components/request/change-close-date
*/
export default {
  changeCloseDate: {
    title: 'Modification of deadline',
    label1: 'Response Deadline',
    button1: 'Extend term',
    script: {
      methods: {
        send: {
          notify: {
            title: 'Response time extension',
            message: 'Response time extension sent successfully.',
          },
          catch: {
            title: 'Modification request',
            message: 'An error occurred while submitting your modification request.',
          },
        },
        confirmSend: {
          label1: 'Are you sure to change the reply deadline?',
          label2: 'Warning',
          confirmButton: 'OK',
          cancelButton: 'Cancel',
          notify: {
            title: 'Response time extension',
            message: 'The extension of the response time has been canceled.',
          },
          catch: {
            title: 'Response time extension',
            message: 'The extension of the response time has been canceled',
          },
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/request_information/components/ChangeCloseDate.js